import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AboutYouForm from "../../interactive/AboutYouForm";
import IdleHelpPanel from "../../interactive/IdleHelpPanel";
import { fetch, omit, referrerPathname } from "../../../modules/utils";
import { updatePageTitle } from "../../../modules/legacyUtils";
import { showIdleHelpPanel, onInteractionWithForm } from "../../../modules/idleHelpPanel";
import { trackEvent } from "../../../modules/tracking";
import { AnalyticsEvents } from "../../../modules/analyticsEvents";
const Index = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [fetching, setFetching] = useState(true);
    const [disabled, setDisabled] = useState(false);
    const [, setFlash] = useState(false);
    const [, setFlashType] = useState('info');
    const [user, setUser] = useState({});
    const [finance, setFinance] = useState({});
    const [errors, setErrors] = useState({});
    const [leadText, setLeadText] = useState(null);
    const [onSignUpWizard, setOnSignUpWizard] = useState(false);
    const hasTrackedView = useRef(false); // Where to send the user on cancel/after saving, when not in the sign-up
    // wizard. This page is reached both via client-side SPA navigation (in
    // which case the previous route is passed as router state) and via full
    // page loads (e.g. from the sign-up wizard's redirectTo() steps), so fall
    // back to the (same-origin) document.referrer in that case. Using
    // client-side paths here (rather than the raw absolute referrer URL) keeps
    // the resulting navigate() calls working as in-SPA navigation.
    const returnPath = onSignUpWizard ? null : location.state?.prevPathname || referrerPathname();
    useEffect(() => { updatePageTitle('About you'); fetch('GET', '/about_you.json').then(data => { setUser(data.user || {}); setFinance(data.finance || {}); setLeadText(data.intro); setOnSignUpWizard(data.on_sign_up_wizard); setFetching(false); }).catch(() => { setFetching(false); }); }, []);
    useEffect(() => { if (!hasTrackedView.current) {
        hasTrackedView.current = true;
        trackEvent(AnalyticsEvents.screenViews.aboutYou());
    } }, []);
    const onChangeUser = (name, value) => {
        const updateObj = typeof name === 'object' ? name : { [name]: value };
        setDisabled(false);
        setUser(prevUser => ({ ...prevUser, ...updateObj })); // Clear errors for updated fields
        const updatedKeys = Object.keys(updateObj);
        setErrors(prevErrors => omit(prevErrors, updatedKeys));
        onInteractionWithForm();
    };
    const onChangeFinance = (name, value) => {
        const updateObj = typeof name === 'object' ? name : { [name]: value };
        setDisabled(false);
        setFinance(prevFinance => ({ ...prevFinance, ...updateObj })); // Clear errors for updated fields
        const updatedKeys = Object.keys(updateObj);
        setErrors(prevErrors => omit(prevErrors, updatedKeys));
        onInteractionWithForm();
    };
    const handleCancel = e => { if (e)
        e.preventDefault(); if (returnPath) {
        navigate(returnPath);
    } };
    const handleSubmit = e => { e.preventDefault(); trackEvent(AnalyticsEvents.forms.submittedAboutYou()); setDisabled(true); fetch('POST', '/about_you', 'application/json', 'application/json', { user: user, finance: finance, utf8: '✓' }).then(data => { if (returnPath) {
        navigate(returnPath);
    }
    else if (data.after_update_path) {
        navigate(data.after_update_path);
    } }).catch(errResponse => { const data = errResponse[1]; setDisabled(false); if (data.errors)
        setErrors(data.errors); if (data.flash !== undefined)
        setFlash(data.flash); if (data.flashType !== undefined)
        setFlashType(data.flashType); }); };
    if (fetching) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Fragment, null, /*#__PURE__*/ React.createElement(AboutYouForm, { onSubmit: handleSubmit, onCancel: handleCancel, onChangeUser: onChangeUser, onChangeFinance: onChangeFinance, disabled: disabled, user: user, finance: finance, errors: errors, leadText: leadText, showCancelButton: !onSignUpWizard, submitButtonLabel: onSignUpWizard ? 'Continue' : 'Save changes', referrer: returnPath ?? undefined }), showIdleHelpPanel(returnPath) && /*#__PURE__*/ React.createElement(IdleHelpPanel, { page: "aboutYou" }));
};
export default Index;
